// extracted by mini-css-extract-plugin
export default {"riddleContainer":"Riddle_riddleContainer__EYi45"};